import { render, staticRenderFns } from "./BranchDetail.vue?vue&type=template&id=8e489354&scoped=true"
import script from "./BranchDetail.vue?vue&type=script&lang=js"
export * from "./BranchDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e489354",
  null
  
)

export default component.exports